import { Link } from "react-router-dom";
import { FaUser, FaCalendarAlt, FaPlaneDeparture, FaWalking, FaRedo, FaCalendarCheck, FaClipboardCheck } from "react-icons/fa";

const Leave = () => {
  const links = [
    { name: "Leave", path: "leave_page/", icon: <FaPlaneDeparture /> },
    { name: "OD", path: "od/", icon: <FaWalking /> },
    { name: "CO+", path: "co+/", icon: <FaRedo /> },
    { name: "Check Leave Balances", path: "leave-balance/", icon: <FaCalendarCheck /> },
    { name: "Leave Balance", path: "check-leave-balance/", icon: <FaClipboardCheck /> },
    { name: "Public Holiday Calender", path: "holiday-calender/", icon: <FaCalendarAlt /> },
  ];

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full p-6 bg-white shadow-lg rounded-lg">
      {links.map((link, index) => (
        <Link to={link.path} className="text-gray-700 hover:text-blue-600 font-medium">
          <li key={index} className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg hover:bg-blue-100 transition">
            <span className="text-blue-500 text-xl">{link.icon}</span>
            {link.name}
          </li>
        </Link>
      ))}
    </ul>
  );
};

export default Leave;